import React, { useState } from "react";
import Seo from "./Seo";

/**
 * Consulting page - Joint consulting practice with dual expertise.
 * Combines technical security engineering with strategic security advisory.
 */

// SVG Icons
const ShieldCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <path d="M9 12l2 2 4-4"/>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const TargetIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

const FileTextIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <line x1="10" y1="9" x2="8" y2="9"/>
  </svg>
);

const CodeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </svg>
);

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// Service Area Icons
const AppSecIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2"/>
    <polyline points="2 17 12 22 22 17"/>
    <polyline points="2 12 12 17 22 12"/>
  </svg>
);

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
  </svg>
);

const DatabaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="5" rx="9" ry="3"/>
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
  </svg>
);

const GRCIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 11l3 3L22 4"/>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
  </svg>
);

const IAMIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M12 1v6"/>
    <path d="M12 17v6"/>
    <path d="M4.22 4.22l4.24 4.24"/>
    <path d="M15.54 15.54l4.24 4.24"/>
    <path d="M1 12h6"/>
    <path d="M17 12h6"/>
    <path d="M4.22 19.78l4.24-4.24"/>
    <path d="M15.54 8.46l4.24-4.24"/>
  </svg>
);

const IRIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const NetworkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
    <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
    <line x1="6" y1="6" x2="6.01" y2="6"/>
    <line x1="6" y1="18" x2="6.01" y2="18"/>
  </svg>
);

const SOCIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <circle cx="12" cy="11" r="1"/>
  </svg>
);

const VulnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    <line x1="11" y1="8" x2="11" y2="14"/>
    <line x1="8" y1="11" x2="14" y2="11"/>
  </svg>
);

const TrainingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
    <path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </svg>
);

const EndpointIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);

const ManagedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);

export default function Consulting() {
  const [expandedService, setExpandedService] = useState(null);

  const toggleService = (id) => {
    setExpandedService(expandedService === id ? null : id);
  };

  // Service areas data (GuidePoint-style)
  const serviceAreas = [
    {
      id: "appsec",
      title: "Application Security",
      icon: <AppSecIcon />,
      description: "Ensure all software releases are secure through comprehensive testing and secure development practices.",
      services: [
        "Web Application Penetration Testing",
        "API Security Assessment",
        "Source Code Review",
        "Secure SDLC Implementation",
        "OWASP Top 10 Coverage",
        "Mobile Application Testing",
      ],
    },
    {
      id: "cloud",
      title: "Cloud Security",
      icon: <CloudIcon />,
      description: "Adapt cybersecurity to cloud transformation across your enterprise with AWS, Azure, and GCP expertise.",
      services: [
        "Cloud Security Posture Assessment",
        "AWS/Azure/GCP Hardening",
        "Container & Kubernetes Security",
        "Infrastructure as Code Review",
        "Cloud Compliance (SOC2, ISO 27001)",
        "Zero Trust Architecture",
      ],
    },
    {
      id: "datasec",
      title: "Data Security",
      icon: <DatabaseIcon />,
      description: "Overcome data security challenges and improve data protection to fit your needs and environment.",
      services: [
        "Data Classification Strategy",
        "Encryption Implementation",
        "Database Security Assessment",
        "Data Loss Prevention (DLP)",
        "Privacy Impact Assessments",
        "GDPR Compliance",
      ],
    },
    {
      id: "grc",
      title: "Governance, Risk & Compliance",
      icon: <GRCIcon />,
      description: "Align your security program with industry best practices while managing risk and addressing compliance mandates.",
      services: [
        "Security Program Assessment",
        "Risk Assessment & Quantification",
        "ISO 27001 Implementation",
        "SOC 2 Readiness",
        "Policy Development",
        "Third-Party Risk Management",
      ],
    },
    {
      id: "iam",
      title: "Identity & Access Management",
      icon: <IAMIcon />,
      description: "Enable business operations through access governance and process automation.",
      services: [
        "IAM Architecture Review",
        "Privileged Access Management",
        "SSO/SAML Implementation",
        "Access Reviews & Certification",
        "Zero Trust Identity",
        "MFA Strategy",
      ],
    },
    {
      id: "ir",
      title: "Incident Response & Threat Intelligence",
      icon: <IRIcon />,
      description: "Prepare for, respond to, and resolve security incidents through effective frameworks and threat intelligence.",
      services: [
        "IR Plan Development",
        "Tabletop Exercises",
        "Threat Hunting",
        "SIEM Implementation",
        "Detection Engineering",
        "Forensic Investigation",
      ],
    },
    {
      id: "network",
      title: "Network & Infrastructure",
      icon: <NetworkIcon />,
      description: "Ensure the integrity and security of your physical and virtual networks.",
      services: [
        "Network Penetration Testing",
        "Firewall Configuration Review",
        "Network Segmentation",
        "VPN Security Assessment",
        "Wireless Security Testing",
        "Linux/Windows Hardening",
      ],
    },
    {
      id: "soc",
      title: "Security Operations",
      icon: <SOCIcon />,
      description: "Gain greater visibility into security events, reduce remediation time, and improve your overall security posture.",
      services: [
        "SOC Maturity Assessment",
        "SIEM Optimization",
        "Playbook Development",
        "Alert Tuning",
        "Log Management Strategy",
        "Wazuh Implementation",
      ],
    },
    {
      id: "vuln",
      title: "Vulnerability Management & Penetration Testing",
      icon: <VulnIcon />,
      description: "Identify and prioritize vulnerabilities to assess your organization's readiness to withstand attacks.",
      services: [
        "Vulnerability Assessment",
        "External/Internal Penetration Testing",
        "Red Team Exercises",
        "Social Engineering",
        "Purple Team Assessment",
        "Remediation Verification",
      ],
    },
    {
      id: "training",
      title: "Security Awareness & Training",
      icon: <TrainingIcon />,
      description: "Instructor-led security services customized to address your organization's specific needs.",
      services: [
        "Phishing Simulation",
        "Security Awareness Programs",
        "Developer Security Training",
        "Executive Security Briefings",
        "Incident Response Training",
        "Custom Workshops",
      ],
    },
    {
      id: "endpoint",
      title: "Endpoint Security",
      icon: <EndpointIcon />,
      description: "Identify and manage the right endpoint security technologies for your unique requirements.",
      services: [
        "EDR Implementation",
        "Endpoint Hardening",
        "Mobile Device Management",
        "Antivirus Strategy",
        "Patch Management",
        "DLP Deployment",
      ],
    },
    {
      id: "managed",
      title: "Managed Security Services",
      icon: <ManagedIcon />,
      description: "Leverage skilled resources to manage your security platforms so you can focus on reducing cyber risk.",
      services: [
        "Virtual CISO",
        "Managed Detection & Response",
        "Continuous Monitoring",
        "Security Program Management",
        "Compliance Management",
        "Ongoing Advisory",
      ],
    },
  ];
  const consultingJsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "LinuxSecOps Consulting",
    description: "Security engineering and strategic advisory services combining hands-on technical expertise with business-aligned risk consulting.",
    serviceType: [
      "Penetration Testing",
      "Security Assessment",
      "Vulnerability Assessment",
      "Cybersecurity Consulting",
      "Compliance Consulting",
      "DevSecOps",
    ],
    areaServed: "Global",
    provider: {
      "@type": "Organization",
      name: "LinuxSecOps",
      url: "https://www.linuxsecops.org",
    },
  };

  const teamExpertise = [
    {
      role: "Technical Security",
      focus: "Engineering & Implementation",
      description: "Our technical security team focuses on building and hardening security infrastructure, implementing DevSecOps practices, and providing hands-on engineering solutions for complex security challenges.",
      areas: [
        "DevSecOps architecture and CI/CD hardening",
        "Cloud infrastructure security (AWS/Azure/GCP)",
        "Linux hardening and container security",
        "Security automation and custom tooling",
        "SIEM implementation and SOC operations",
        "Technical reports with proof-of-concept",
      ],
      icon: <CodeIcon />,
    },
    {
      role: "Penetration Testing",
      focus: "Offensive Security & Red Team",
      description: "Our offensive security team identifies vulnerabilities through comprehensive penetration testing, conducts realistic attack simulations, and provides actionable insights to strengthen your security posture.",
      areas: [
        "Web application penetration testing",
        "API security assessment",
        "Network and infrastructure testing",
        "Vulnerability assessment and exploitation",
        "Social engineering and phishing simulations",
        "Red team operations",
      ],
      icon: <VulnIcon />,
    },
  ];

  const packages = [
    {
      id: "baseline",
      name: "Security Baseline Review",
      duration: "2-3 weeks",
      price: "€2,000 - €3,000",
      description: "High-level security assessment for organizations seeking to understand their current posture and key risks.",
      features: [
        "Technical configuration review",
        "Risk and compliance gap analysis",
        "Priority-ranked findings",
        "Executive summary for management",
        "Remediation roadmap",
      ],
      ideal: "SMEs, startups, organizations without dedicated security team",
      featured: false,
    },
    {
      id: "assessment",
      name: "Technical Security Assessment",
      duration: "3-5 weeks",
      price: "From €5,000",
      description: "Comprehensive technical assessment combining penetration testing with strategic risk analysis.",
      features: [
        "Web/API penetration testing",
        "Infrastructure and cloud review",
        "Vulnerability assessment with validation",
        "Detailed technical report",
        "Business impact analysis",
        "Remediation guidance with priorities",
      ],
      ideal: "Product companies, SaaS, fintech, healthtech",
      featured: true,
    },
    {
      id: "advisory",
      name: "Continuous Security Advisory",
      duration: "Monthly retainer",
      price: "From €1,000/month",
      description: "Ongoing security partnership for organizations that need continuous guidance without building an in-house team.",
      features: [
        "Quarterly security reviews",
        "Security roadmap development",
        "Architecture review for new features",
        "Incident response planning",
        "On-call consultation",
        "Executive reporting",
      ],
      ideal: "Growing companies, scale-ups, regulated industries",
      featured: false,
    },
  ];

  const processSteps = [
    {
      number: "01",
      title: "Discovery",
      description: "30-minute call to understand your environment, concerns, and objectives.",
      duration: "Free",
    },
    {
      number: "02",
      title: "Scoping",
      description: "Define assessment boundaries, deliverables, timeline, and commercial terms.",
      duration: "1-2 days",
    },
    {
      number: "03",
      title: "Execution",
      description: "Technical assessment and analysis conducted by our team.",
      duration: "Per package",
    },
    {
      number: "04",
      title: "Reporting",
      description: "Dual deliverables: technical report for your team, executive summary for management.",
      duration: "Included",
    },
    {
      number: "05",
      title: "Follow-up",
      description: "Debrief session to discuss findings and answer questions.",
      duration: "Included",
    },
  ];

  const differentiators = [
    {
      title: "Dual Perspective",
      description: "Every engagement combines technical depth with business context. You get actionable findings and risk-aligned recommendations.",
    },
    {
      title: "Senior-Only Team",
      description: "No junior rotation. Direct access to experienced practitioners who understand enterprise environments.",
    },
    {
      title: "Practical Outcomes",
      description: "We focus on what matters. Prioritized findings, realistic timelines, and remediation you can actually implement.",
    },
    {
      title: "Clear Communication",
      description: "Technical reports for your security team. Executive summaries for your board. No translation needed.",
    },
  ];

  return (
    <div className="consulting-container">
      <Seo
        title="Security Consulting - LinuxSecOps"
        description="Boutique security consulting combining hands-on engineering with strategic advisory. Penetration testing, vulnerability assessments, compliance, and DevSecOps."
        path="/consulting"
        jsonLd={consultingJsonLd}
      />

      {/* Hero Section */}
      <section className="consulting-hero">
        <div className="consulting-hero-content">
          <div className="hero-badge">Consulting Practice</div>
          <h1 className="consulting-hero-title">
            Security Engineering
            <span className="consulting-hero-accent"> & Strategic Advisory</span>
          </h1>
          <p className="consulting-hero-description">
            Boutique consulting practice combining hands-on technical security engineering 
            with strategic risk advisory. We deliver both the technical depth and business 
            context you need to make informed security decisions.
          </p>
          <div className="consulting-hero-actions">
            <a
              href="mailto:linuxsecops@proton.me"
              className="btn-primary"
            >
              <MailIcon /> Get in Touch
            </a>
            <a
              href="https://calendly.com/linuxsecops-proton/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              <CalendarIcon /> Schedule Discovery Call
            </a>
          </div>
        </div>
      </section>

      {/* Why Different Section */}
      <section className="consulting-content">
        <div className="consulting-section">
          <div className="consulting-section-header">
            <div className="consulting-section-icon">
              <TargetIcon />
            </div>
            <h2 className="consulting-section-title">Why We're Different</h2>
          </div>
          <div className="differentiators-grid">
            {differentiators.map((item) => (
              <div key={item.title} className="differentiator-card">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas Section - GuidePoint Style */}
      <section className="consulting-content">
        <div className="consulting-section services-expertise-section">
          <div className="services-expertise-header">
            <span className="services-label">SERVICES</span>
            <h2 className="services-expertise-title">
              <span className="title-highlight">Expertise</span> Based on Reality - Not Theory
            </h2>
            <p className="services-expertise-subtitle">
              Explore our cybersecurity services and solutions across a wide range of vetted technologies:
            </p>
          </div>
          <div className="services-grid">
            {serviceAreas.map((service) => (
              <div
                key={service.id}
                className={`service-area-card ${expandedService === service.id ? "expanded" : ""}`}
              >
                <button
                  className="service-area-trigger"
                  onClick={() => toggleService(service.id)}
                  aria-expanded={expandedService === service.id}
                >
                  <div className="service-area-icon">{service.icon}</div>
                  <span className="service-area-title">{service.title}</span>
                  <span className={`service-area-chevron ${expandedService === service.id ? "rotated" : ""}`}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {expandedService === service.id && (
                  <div className="service-area-content">
                    <p className="service-area-description">{service.description}</p>
                    <ul className="service-area-list">
                      {service.services.map((item) => (
                        <li key={item}>
                          <CheckIcon />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <a
                      href={`mailto:linuxsecops@proton.me?subject=Inquiry: ${service.title}`}
                      className="service-area-cta"
                    >
                      Request Information <ArrowRightIcon />
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Expertise Section */}
      <section className="consulting-content">
        <div className="consulting-section">
          <div className="consulting-section-header">
            <div className="consulting-section-icon">
              <UsersIcon />
            </div>
            <h2 className="consulting-section-title">Our Expertise</h2>
          </div>
          <p className="consulting-section-intro">
            We operate as a senior-focused security consulting team. Each engagement 
            leverages complementary skills to deliver complete coverage.
          </p>
          <div className="team-grid">
            {teamExpertise.map((capability) => (
              <div key={capability.role} className="team-card">
                <div className="team-card-header">
                  <div className="team-icon">{capability.icon}</div>
                  <div className="team-role-info">
                    <h3 className="team-role">{capability.role}</h3>
                    <p className="team-focus-badge">{capability.focus}</p>
                  </div>
                </div>
                <p className="team-description">{capability.description}</p>
                <ul className="team-areas">
                  {capability.areas.map((area) => (
                    <li key={area}>
                      <CheckIcon />
                      <span>{area}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="consulting-content">
        <div className="consulting-section">
          <div className="consulting-section-header">
            <div className="consulting-section-icon">
              <ShieldCheckIcon />
            </div>
            <h2 className="consulting-section-title">Service Packages</h2>
          </div>
          <p className="consulting-section-intro">
            Structured engagements designed for different needs and maturity levels. 
            All packages include both technical assessment and strategic recommendations.
          </p>
          <div className="packages-grid">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className={`package-card ${pkg.featured ? "package-card-featured" : ""}`}
              >
                {pkg.featured && <div className="package-badge">Most Popular</div>}
                <div className="package-header">
                  <h3 className="package-name">{pkg.name}</h3>
                  <div className="package-meta">
                    <span className="package-duration">{pkg.duration}</span>
                    <span className="package-price">{pkg.price}</span>
                  </div>
                </div>
                <p className="package-description">{pkg.description}</p>
                <ul className="package-features">
                  {pkg.features.map((feature) => (
                    <li key={feature}>
                      <CheckIcon />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="package-ideal">
                  <strong>Ideal for:</strong> {pkg.ideal}
                </div>
                <a
                  href={`mailto:linuxsecops@proton.me?subject=Inquiry: ${pkg.name}`}
                  className={`package-cta ${pkg.featured ? "package-cta-primary" : ""}`}
                >
                  Request Quote <ArrowRightIcon />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="consulting-content">
        <div className="consulting-section">
          <div className="consulting-section-header">
            <div className="consulting-section-icon">
              <FileTextIcon />
            </div>
            <h2 className="consulting-section-title">Our Process</h2>
          </div>
          <div className="process-timeline">
            {processSteps.map((step, index) => (
              <div key={step.number} className="process-timeline-item">
                <div className="process-number">{step.number}</div>
                <div className="process-content">
                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                  <span className="process-duration">{step.duration}</span>
                </div>
                {index < processSteps.length - 1 && (
                  <div className="process-connector" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="consulting-cta">
        <div className="consulting-cta-content">
          <h2 className="consulting-cta-title">
            Ready to discuss your security posture?
          </h2>
          <p className="consulting-cta-description">
            Start with a free 30-minute discovery call. No sales pitch - just an honest 
            conversation about your environment and how we might help.
          </p>
          <div className="consulting-cta-actions">
            <a
              href="https://calendly.com/linuxsecops-proton/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <CalendarIcon /> Schedule Discovery Call
            </a>
            <a
              href="mailto:linuxsecops@proton.me"
              className="btn-secondary"
            >
              <MailIcon /> linuxsecops@proton.me
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

